import { useSyncExternalStore } from "react";

let owner: string | undefined;
let paused = false;
let generation = 0;
export const sessionGeneration = () => generation;
const listeners = new Set<() => void>();
const publish = () => listeners.forEach((listener) => listener());

/** No tokens or clinical content live in this store. */
export function setSessionOwner(id?: string) {
  if (id !== owner || paused) generation++;
  owner = id;
  paused = false;
  publish();
}
export function suspendSession() {
  if (!owner) return false;
  if (!paused) generation++;
  paused = true;
  publish();
  return true;
}
export function sessionIsPaused() {
  return paused;
}
export const isSessionOwner = (id: string) => owner === id;

export function resumeSession(id: string) {
  if (id !== owner) return false;
  paused = false;
  publish();
  window.dispatchEvent(new Event("care:session-resumed"));
  return true;
}
export function useSessionPaused() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    sessionIsPaused,
    () => false,
  );
}
